import { render, staticRenderFns } from "./OptionSet.vue?vue&type=template&id=bbbc66b4&scoped=true&"
import script from "./OptionSet.vue?vue&type=script&lang=js&"
export * from "./OptionSet.vue?vue&type=script&lang=js&"
import style0 from "./OptionSet.vue?vue&type=style&index=0&id=bbbc66b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbc66b4",
  null
  
)

export default component.exports